const loginButton = ({button: {className, onClick, id, text}}) => {
  return (
    <button className={className} onClick={event => onClick(event)} id={id}>
      {text}
    </button>
  );
};

export default loginButton;
